export type CountryKeys = 'peru' | 'mexico' | 'guyana' | 'brazil' | 'bolivia' | 'paraguay' | 'argentina' | 'chile' | 'neutro'

export const COUNTRY_COLORS: { [key in CountryKeys]: string } = {
  peru: '#75A5EA',
  mexico: '#E8FF0F',
  guyana: '#FFED5E',
  brazil: '#8BD0B3',
  bolivia: '#0056E0',
  paraguay: '#00A6FC',
  argentina: '#1BCC7B',
  chile: '#98DCF9',
  neutro: '#F1F1ED',
}

